import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const RoninLogoSquare = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <g fill="none" fillRule="nonzero"><rect fill="#004DE5" height={24} rx={0} width={24} /><path d="M5.57 5.385V16.49a1.38 1.38 0 0 0 .521 1.08l5.256 4.202a1.045 1.045 0 0 0 1.303 0l5.256-4.202a1.385 1.385 0 0 0 .521-1.08V5.385c0-.368-.146-.72-.407-.98A1.393 1.393 0 0 0 17.037 4H6.96c-.369 0-.722.146-.983.406-.26.26-.407.611-.407.979Zm8.977 1.4c.318 0 .623.128.848.355.225.227.351.535.351.856v2.42c0 .32-.126.628-.35.855a1.194 1.194 0 0 1-.847.355c.318 0 .623.128.848.355.225.227.352.535.352.856v2.182a1.219 1.219 0 0 1-.45.944l-1.857 1.503a.149.149 0 0 1-.22-.037.152.152 0 0 1-.023-.08v-4.21a.912.912 0 0 0-.264-.642.896.896 0 0 0-.636-.266h-1.35a.15.15 0 0 0-.15.152v4.965a.152.152 0 0 1-.085.137.149.149 0 0 1-.159-.019l-1.856-1.503a1.208 1.208 0 0 1-.45-.944V7.996c0-.321.126-.629.351-.856.225-.227.53-.354.848-.354Zm-1.5 1.21h-2.1a.15.15 0 0 0-.105.045.152.152 0 0 0-.044.107v2.723c0 .04.016.079.044.107a.15.15 0 0 0 .106.044h1.35a.896.896 0 0 0 .636-.266.912.912 0 0 0 .263-.641V8.147a.152.152 0 0 0-.044-.107.15.15 0 0 0-.106-.044Z" fill="#FFF" /></g>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== className || $[8] !== rest || $[9] !== t2) {
    t4 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = className;
    $[8] = rest;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export const RoninLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm17.037 4H6.96c-.369 0-.722.146-.983.406-.26.26-.407.611-.407.979V16.49a1.38 1.38 0 0 0 .521 1.08l5.256 4.202a1.045 1.045 0 0 0 1.303 0l5.256-4.202a1.385 1.385 0 0 0 .521-1.08V5.385c0-.368-.146-.72-.407-.98A1.393 1.393 0 0 0 17.037 4Zm-2.49 2.786c.318 0 .623.127.848.354.225.227.351.535.351.856v2.42c0 .32-.126.628-.35.855a1.194 1.194 0 0 1-.847.355c.318 0 .623.128.848.355.225.227.352.535.352.856v2.182a1.219 1.219 0 0 1-.45.944l-1.857 1.503a.149.149 0 0 1-.22-.037.152.152 0 0 1-.023-.08v-4.21a.912.912 0 0 0-.264-.642.896.896 0 0 0-.636-.266h-1.35a.15.15 0 0 0-.15.152v4.965a.152.152 0 0 1-.085.137.149.149 0 0 1-.159-.019l-1.856-1.503a1.208 1.208 0 0 1-.45-.944V7.996c0-.321.126-.629.351-.856.225-.227.53-.354.848-.354Zm-1.5 1.21h-2.1a.15.15 0 0 0-.105.044.152.152 0 0 0-.044.107v2.723c0 .04.016.079.044.107a.15.15 0 0 0 .106.044h1.35a.896.896 0 0 0 .636-.266.912.912 0 0 0 .263-.641V8.147a.152.152 0 0 0-.044-.107.15.15 0 0 0-.106-.044Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};